<div class="list">
    @for (afd of this.kopInfo; track afd.refnr) {
        @let afdIsWarning = afd.validInArm != 'Valid';

        <div>
            <div  class="grid4 header" [class.warning]="afdIsWarning">
                <div>Afdeling</div>
                <div>Ref</div>
                <div>Type</div>
                <div>Valid TM</div>

                <div>{{afd.name}}</div>
                <div>{{afd.refnr}}</div>
                <div>{{afd.type}}</div>
                <div [class.stillValid]="!afdIsWarning">{{afd.validTm}}</div>
            </div>
            <!-- <div class="header">Afedling: {{afd.name}} / ref: {{afd.refnr}} / Type: {{afd.type}}</div>
            <div class="header" [class.warning]="afdIsWarning">{{afd.validInArm}}</div> -->

            <div class="header" [class.warning]="afdIsWarning">AIs</div>
            <div class="grid" [class.warning]="afdIsWarning">
                <div>Index</div>
                <div>Kanaal</div>
                <div>Range</div>
                <div>Omschr</div>
                <div>VersionTm</div>
                @for (ai of afd.ais; track ai.index) {
                    @let isWarning = ai.versionTm != '' && ai.versionTm != undefined;
                    <div [class.warning]="isWarning">{{ai.index}}</div>
                    <div [class.warning]="isWarning">{{this.label(ai.kanaal)}}</div>
                    <div [class.warning]="isWarning">{{ai.range}}</div>
                    <div [class.warning]="isWarning">{{ai.omschr}}</div>
                    <div [class.warning]="isWarning">{{ai.versionTm}}</div>
                }

            </div>


            <div class="header"[class.warning]="afdIsWarning">Los Defs</div>
            <div class="grid" [class.warning]="afdIsWarning">
                <div>Index</div>
                <div>Kanaal/Waarde</div>
                <div>Range</div>
                <div>Omschr</div>
                <div>VersionTm</div>
                @for (ld of afd.losdefs; track ld.index) {
                    @let isWarning = ld.versionTm != '' && ld.versionTm != undefined;
                    <div [class.warning]="isWarning">{{ld.index}}</div>
                    <div [class.warning]="isWarning">{{ld.waarde}}</div>
                    <div [class.warning]="isWarning">{{ld.range}}</div>
                    <div [class.warning]="isWarning">{{ld.omschr}}</div>
                    <div [class.warning]="isWarning">{{ld.versionTm}}</div>
                }

            </div>

            @if (afd.koelings.length > 0) {
                <div class="header" [class.warning]="afdIsWarning">Koeling</div>
                <div class="grid" [class.warning]="afdIsWarning">
                    <div>Index</div>
                    <div>Kanaal/Waarde</div>
                    <div>Range</div>
                    <div>Omschr</div>
                    <div>VersionTm</div>
                    @for (ld of afd.koelings; track ld.index) {
                        @let isWarning = ld.versionTm != '' && ld.versionTm != undefined;
                        <div [class.warning]="isWarning">{{ld.index}}</div>
                        <div [class.warning]="isWarning">{{ld.waarde}}</div>
                        <div [class.warning]="isWarning">{{ld.range}}</div>
                        <div [class.warning]="isWarning">{{ld.omschr}}</div>
                        <div [class.warning]="isWarning">{{ld.versionTm}}</div>
                    }

                </div>
            }

            @if (afd.verwarmings.length > 0) {
                <div class="header" [class.warning]="afdIsWarning">Verwarming</div>
                <div class="grid" [class.warning]="afdIsWarning">
                    <div>Index</div>
                    <div>Kanaal/Waarde</div>
                    <div>Range</div>
                    <div>Omschr</div>
                    <div>VersionTm</div>
                    @for (ld of afd.verwarmings; track ld.index) {
                        @let isWarning = ld.versionTm != '' && ld.versionTm != undefined;
                        <div [class.warning]="isWarning">{{ld.index}}</div>
                        <div [class.warning]="isWarning">{{ld.waarde}}</div>
                        <div [class.warning]="isWarning">{{ld.range}}</div>
                        <div [class.warning]="isWarning">{{ld.omschr}}</div>
                        <div [class.warning]="isWarning">{{ld.versionTm}}</div>
                    }

                </div>
            }

            @if (afd.droogWands.length > 0) {
                <div class="header" [class.warning]="afdIsWarning">Droogwand</div>
                <div class="grid" [class.warning]="afdIsWarning">
                    <div>Index</div>
                    <div>Kanaal/Waarde</div>
                    <div>Range</div>
                    <div>Omschr</div>
                    <div>VersionTm</div>
                    @for (ld of afd.droogWands; track ld.index) {
                        @let isWarning = ld.versionTm != '' && ld.versionTm != undefined;
                        <div [class.warning]="isWarning">{{ld.index}}</div>
                        <div [class.warning]="isWarning">{{ld.waarde}}</div>
                        <div [class.warning]="isWarning">{{ld.range}}</div>
                        <div [class.warning]="isWarning">{{ld.omschr}}</div>
                        <div [class.warning]="isWarning">{{ld.versionTm}}</div>
                    }

                </div>
            }

            @if (afd.servos.length > 0) {
                <div class="header" [class.warning]="afdIsWarning">Servos</div>
                <div class="grid" [class.warning]="afdIsWarning">
                    <div>Index</div>
                    <div>Kanaal</div>
                    <div>Range</div>
                    <div>Omschr</div>
                    <div>VersionTm</div>
                    @for (servo of afd.servos; track servo.index) {
                        @let isWarning = servo.versionTm != '' && servo.versionTm != undefined;
                        <div [class.warning]="isWarning">{{servo.index}}</div>
                        <div [class.warning]="isWarning">{{servo.kanaal}}</div>
                        <div [class.warning]="isWarning">{{servo.range}}</div>
                        <div [class.warning]="isWarning">{{servo.omschr}}</div>
                        <div [class.warning]="isWarning">{{servo.versionTm}}</div>
                    }

                </div>
            }

            @if (afd.bijzPrgms.length > 0) {
                <div class="header" [class.warning]="afdIsWarning">BijzPrgm</div>
                <div class="grid" [class.warning]="afdIsWarning">
                    <div>Index</div>
                    <div>Kanaal</div>
                    <div>Range</div>
                    <div>Omschr</div>
                    <div>VersionTm</div>
                    @for (bp of afd.bijzPrgms; track bp.index) {
                        @let isWarning = bp.versionTm != '' && bp.versionTm != undefined;
                        <div [class.warning]="isWarning">{{bp.index}}</div>
                        <div [class.warning]="isWarning">{{bp.kanaal}}</div>
                        <div [class.warning]="isWarning">{{bp.range}}</div>
                        <div [class.warning]="isWarning">{{bp.omschr}}</div>
                        <div [class.warning]="isWarning">{{bp.versionTm}}</div>
                    }

                </div>
            }

            
        </div>
    }
</div>